/**
 * Returns true if a given thing is an object
 *
 * @param thing - The thing to check.
 */
export const isObject = (thing: any) => !!thing &&
    !Array.isArray(thing) &&
    typeof thing === 'object';
